<template>
    <div class="ReportListPage">
        <DashboardSectionHeader title="Reports"/>

        <DashboardList :columns="['Report']">
            <DashboardListItem
                v-for="report in reports"
                :key="report.type"
                :columns="[report.title]"
                :actions="[{
                    label: 'View',
                    click: () => $router.push(`/company/reports/view?type=${report.type}`)
                }]"
            />
        </DashboardList>
    </div>
</template>

<script>
import * as api from '@/api';
import { mapState } from 'vuex';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardList from '@/components/DashboardList';
import DashboardListItem from '@/components/DashboardListItem';

export default {
    name: 'ReportListPage',

    components: { DashboardSectionHeader, DashboardList, DashboardListItem },

    data: () => ({
        reports: [
            { title: 'Ticket Summary', type: 'tickets' },
            { title: 'Employee Timesheet', type: 'timesheets' },
            { title: 'Hauling Ticket', type: 'hauling' },
            { title: 'Project Report', type: 'projects' },
            { title: 'Material Report', type: 'materials' },
            { title: 'Detailed Hauling Ticket (beta)', type: 'detailedHauling' },
        ],
    }),

    computed: {
        ...mapState('company', ['projects']),
    },
}
</script>

